import { jModal } from './jquery_modal/jquery_modal';
import { coxToPDF } from './js_to_pdf/js_to_pdf';
import { ECFront } from './certificate-select-region/certificate-front';

jQuery(document).ready(function($){
  jModal($)
  coxToPDF($)
  ECFront($)
  //console.log(FieldConditionalDisplay)
});
